import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'react-bootstrap';

const InfoList = ({ items }) => (
  <ListGroup variant="flush">
    {items.map((it, idx) => {
      const shouldHighlight = it.highlight && Number(it.raw) && Number(it.raw) !== 0;
      return (
        <ListGroup.Item key={idx} className="px-0 py-2 border-0">
          <div className="small text-muted">{it.label}</div>
          <div className={`fw-semibold ${shouldHighlight ? 'text-danger' : ''}`}>{it.value || '-'}</div>
        </ListGroup.Item>
      );
    })}
  </ListGroup>
);

InfoList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      raw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      highlight: PropTypes.bool
    })
  ).isRequired
};

export default InfoList;
